import React, { useState,useEffect } from 'react';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import pdf1 from '../../assets/digitalparag/pdf/1.pdf'; // PDF for document1
import pdf2 from '../../assets/digitalparag/pdf/2.pdf'; // Uploaded PDF for document2
import p2df1 from '../../assets/digitalparag/pdf2/1.pdf'; // Uploaded PDF for document2
import p3df1 from '../../assets/digitalparag/pdf3/1.pdf'; // Uploaded PDF for document2
import { api_url } from "../../helpers/apiHelpers";

// Function to render the PDF
const PDFViewer = ({ fileUrl }) => {
  if (!fileUrl) return <p>No document selected</p>;
  return (
    <div className="w-full h-[500px] overflow-hidden rounded-lg border-2 border-gray-200 shadow-inner">
    {/* PDF.js Worker */}
    <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}>
      <Viewer fileUrl={fileUrl} />
    </Worker>
  </div>
  );
};

const GovtBooksGr = () => {
  const [pdfFile, setPdfFile] = useState(null);

  const [selectedBookData, setSelectedBookData] = useState(null);
  const [bookData, setBookData] = useState([]);
  const [bookTitleData, setBookTitleData] = useState([]);

  const getBookTitleData = async () => {
      const response = await fetch(`${api_url}/api/admin/all-booktitle`);
      const result = await response.json();
  
      if (result.status === 201) {
          setBookTitleData(result.result)
      } else {
          setBookTitleData([])
      }
  }
 

  const getBookData = async () => {
      const response = await fetch(`${api_url}/api/admin/get-bookpdf-data`);
      const result = await response.json();
      if (result.status === 201) {
          setBookData(result.result)
      } else {
          setBookData([])
      }
  }

  useEffect(() => {
      getBookTitleData();
      getBookData();
  }, [])

  const selectBook = (value) =>{
    const data = bookData.find((item)=>item._id === value);
    setSelectedBookData(data)
    setPdfFile(`${api_url}/bookpdf/${data.bookFile}`)
  }


  // Function to handle PDF download
  const downloadPDF = () => {
    if (pdfFile) {
      const link = document.createElement('a');
      link.href = pdfFile;
      link.download = pdfFile.split('/').pop(); // Extract the filename from the path
      link.click();
    }
  };

  // Dropdown change handler for each dropdown
  const handleDocumentChange1 = (e) => {
    const selectedValue = e.target.value;
    if (selectedValue === 'document1') {
      setPdfFile(pdf1);
    } else if (selectedValue === 'document2') {
      setPdfFile(pdf2);
    } else {
      setPdfFile(null);
    }
  };

  const handleDocumentChange2 = (e) => {
    const selectedValue = e.target.value;
    if (selectedValue === 'documen1') {
      setPdfFile(p2df1);
    } else if (selectedValue === 'document2') {
      setPdfFile(pdf2);
    } else {
      setPdfFile(null);
    }
  };

  const handleDocumentChange3 = (e) => {
    const selectedValue = e.target.value;
    if (selectedValue === 'documentt1') {
      setPdfFile(p3df1);
    } else {
      setPdfFile(null);
    }
  };

  return (
    <div>
      <Header />
      <div className="container mx-auto py-10">
        <div className="row">
          <div className="col-lg-9 m-auto">
            <div className="row">
              <div className="col-lg-5">

                  {/* Left Side (Upload & Select Document) */}
                  <div className="w-full h-100 p-3 bg-white border border-gray-300 rounded-lg shadow-xl transition-shadow hover:shadow-2xl text-base">
                    <h2 className="text-xl font-semibold mb-4"> Select Books </h2>
                    {
                      bookTitleData && bookTitleData.map((item,index)=>(
                        <div class="dropdown mt-2">
                          <button class="text-left text-sm btn btn-outline-primary w-100 dropdown-toggle" type="button" id={`dropdownMenuButton1${index+1}`} data-bs-toggle="dropdown" aria-expanded="false">
                            {item.bookTitle}
                          </button>
                          <ul class="dropdown-menu" aria-labelledby={`dropdownMenuButton1${index+1}`}>
                            { 
                              bookData && bookData.map((items)=>{
                                if(item.bookTitle == items.bookTitle){
                                  console.log(items);
                                  
                                  return(<li><a class="dropdown-item" href="#" onClick={()=>selectBook(items._id)}>{items.bookName}</a></li>)
                                }
                              })
                            }
                          </ul>
                        </div>
                      ))
                    }
                  </div>
                </div>
                <div className="col-lg-7">
                  {/* Right Side (PDF Preview and Download Button) */}
                  <div className="w-full h-100 p-3 bg-white border border-gray-300 rounded-lg shadow-xl transition-shadow hover:shadow-2xl relative">
                    <h2 className="text-sm font-semibold mb-4 text-wrap w-75">{selectedBookData && selectedBookData.bookName || 'Preview'}</h2>
                    <div className="w-full overflow-hidden shadow-inner">
                      <PDFViewer fileUrl={pdfFile} /> 
                    </div>

                    {/* Download Button - Positioned to top-right */}
                    {pdfFile && (
                      <button
                        onClick={downloadPDF}
                        className="absolute top-2 right-2 btn btn-primary btn-sm"
                      >
                        Download PDF
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      <Footer />
    </div>
  );
};

export default GovtBooksGr;

{/* <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4234746316648724"
     crossorigin="anonymous"></script> */}
